import React from "react";
import { Form } from "antd";
import InputLabel from "../FloatingLabel/FloatingLabel";

export const FormPickerField = ({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  InputType,
  hasFeedback,
  hideErrorMessage,
  ...props
}) => {
  const errorMessage = hideErrorMessage
    ? false
    : touched[field.name] && errors[field.name];
  let inputStatus;

  const [active, setActive] = React.useState(false);

  const onBlur = () => {
    setActive(false);
  };

  const onFocus = () => {
    setActive(true);
  };

  if (errorMessage) {
    inputStatus = "error";
  } else if (touched[field.name] && field.value) {
    inputStatus = "success";
  }

  return (
    <Form.Item
      help={errorMessage}
      validateStatus={inputStatus}
      hasFeedback={hasFeedback}
      shouldUpdate={(prevValues, currentValues) =>
        prevValues[field.name] !== currentValues[field.name]
      }
    >
      {({ getFieldValue }) => {
        return (
          <InputLabel
            active={active}
            value={getFieldValue(field.name)}
            {...(field.value || field.value === 0
              ? setActive(true)
              : setActive(false))}
            {...props}
          >
            <Form.Item name={field.name} initialValue={field.value}>
              <InputType
                {...field}
                {...props}
                onBlur={onBlur}
                onFocus={onFocus}
              >
                {props.children}
              </InputType>
            </Form.Item>
          </InputLabel>
        );
      }}
    </Form.Item>
  );
};
